import{__assign as o}from'./../../ext/tslib/tslib.es6.js';import t from"react";var e=function(e){return t.createElement("button",o({},e,{onClick:function(o){e.onClick&&e.onClick(o,e.page)}}),e.children)};export{e as PaginationButton};
//# sourceMappingURL=PaginationButton.js.map
